module.exports = __webpack_public_path__ + "images/emoji/movie_camera.825f8e5634eb899600a8.png";